export const WHATSAPP_NUMBER = "4917656198464"; // fallback, server returns canonical

const JOB_TYPE_LABEL = {
  single_item: "Einzelnes Stück",
  single_medium: "Einzelstück (mittel)",
  single_heavy: "Einzelstück (schwer)",
  few_items: "Wenige Gegenstände",
  many_boxes_furniture: "Viele Kartons + Möbel",
  complete_room: "Komplettes Zimmer",
  complete_kitchen: "Komplette Küche",
  many_large_furniture: "Viele große Möbel",
  partial_move: "Teil-Umzug",
  full_move: "Kompletter Umzug",
};

const EFFORT_LABEL = { leicht: "Leicht", mittel: "Mittel", schwer: "Hoch" };

export function buildWhatsappMessage(q, companyName = "Leukas Umzug Service") {
  const typeLabel = q.type === "small" ? "Kleine Transporte" : "Kompletter Umzug";
  const elevator = (v) => (v ? "Ja" : "Nein");
  const detected = Array.isArray(q.detected_items) ? q.detected_items.filter(Boolean) : [];
  const photoUrls = Array.isArray(q.photo_urls) ? q.photo_urls.filter(Boolean) : [];
  const photoCount = q.photo_count ?? (Array.isArray(q.photo_ids) ? q.photo_ids.length : 0);
  const lines = [
    `Hallo ${companyName},`,
    ``,
    `ich möchte ein Angebot anfragen:`,
    `• Typ: ${typeLabel}`,
    `• Name: ${q.first_name || ""} ${q.last_name || ""}`,
    `• Telefon: ${q.phone || ""}`,
    `• WhatsApp: ${q.whatsapp || q.phone || ""}`,
    ``,
    `Abholung:`,
    `• Adresse: ${q.pickup_address || ""}`,
    `• Etage: ${q.pickup_floor ?? 0}`,
    `• Aufzug: ${elevator(q.pickup_elevator)}`,
    ``,
    `Lieferung:`,
    `• Adresse: ${q.delivery_address || ""}`,
    `• Etage: ${q.delivery_floor ?? 0}`,
    `• Aufzug: ${elevator(q.delivery_elevator)}`,
    ``,
    `Wunschdatum: ${q.moving_date || ""}${q.moving_time ? " · " + q.moving_time + " Uhr" : ""}${q.time_window ? " (" + q.time_window + ")" : ""}`,
    ``,
    `Geschätztes Angebot: ${q.estimate_min}€ – ${q.estimate_max}€`,
  ];
  if (q.job_type && JOB_TYPE_LABEL[q.job_type]) {
    lines.push(`Geschätzter Auftrag: ${JOB_TYPE_LABEL[q.job_type]}`);
  }
  if (q.effort && EFFORT_LABEL[q.effort]) {
    lines.push(`Geschätzter Aufwand: ${EFFORT_LABEL[q.effort]}`);
  }
  if (detected.length > 0) {
    lines.push(`Erkannte Gegenstände (${detected.length}): ${detected.join(", ")}`);
  }
  if (photoCount > 0) {
    lines.push(`Fotos: ${photoCount}`);
  }
  if (photoUrls.length > 0) {
    lines.push(``, `Foto-Links:`);
    photoUrls.forEach((u, i) => lines.push(`${i + 1}. ${u}`));
  } else if ((q.photo_ids?.length || 0) > 0) {
    lines.push(`(Bilder im Admin-Dashboard verfügbar.)`);
  }
  lines.push(``, `Bitte um finale Bestätigung. Danke!`);
  return lines.join("\n");
}

export function whatsappLink(number, message) {
  const clean = (number || "").toString().replace(/\D/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(message)}`;
}

// --- One-tap submit templates -------------------------------------------

function _line(label, value) {
  const v = (value === null || value === undefined) ? "" : String(value).trim();
  if (!v) return null;
  return `${label}: ${v}`;
}

/** Build the /entruempelung WhatsApp message body */
export function buildClearanceWaMessage(form) {
  const lines = ["Hallo, ich möchte eine Anfrage für eine Entrümpelung senden."];
  const push = (label, value) => { const s = _line(label, value); if (s) lines.push(s); };
  push("Name", form.first_name);
  push("Telefon", form.phone);
  push("E-Mail", form.email);
  push("Adresse / PLZ", form.address);
  push("Objektart", form.object_type);
  if (form.size_m2) push("Größe", `${form.size_m2} m²`);
  const etage = form.floor ? (form.elevator ? `${form.floor}, Aufzug vorhanden` : form.floor) : "";
  push("Etage", etage);
  push("Wunschtermin", form.desired_date);
  if (Array.isArray(form.extras) && form.extras.length) push("Zusatzleistungen", form.extras.join(", "));
  push("Nachricht", form.message);
  return lines.join("\n");
}

/** Build the /angebot WhatsApp message body */
export function buildUmzugWaMessage(form, type) {
  const artLabel = type === "full" ? "Kompletter Umzug" : "Kleiner Transport";
  const lines = ["Hallo, ich möchte eine Anfrage für einen Umzug / Transport senden."];
  const push = (label, value) => { const s = _line(label, value); if (s) lines.push(s); };
  push("Art", artLabel);
  const fullName = [form.first_name, form.last_name].filter(Boolean).join(" ").trim();
  push("Name", fullName);
  push("Telefon", form.phone);
  push("E-Mail", form.email);
  push("Von", form.pickup_address);
  push("Nach", form.delivery_address);
  push("Wohnungsgröße", form.wohnungsgroesse);
  const etageAus = (form.pickup_floor !== undefined && form.pickup_floor !== null && form.pickup_floor !== "") ? String(form.pickup_floor) : "";
  const etageEin = (form.delivery_floor !== undefined && form.delivery_floor !== null && form.delivery_floor !== "") ? String(form.delivery_floor) : "";
  if (etageAus || etageEin) push("Etage Auszug / Einzug", `${etageAus || "?"} / ${etageEin || "?"}`);
  const termin = [form.moving_date, form.moving_time].filter(Boolean).join(" · ");
  push("Wunschtermin", termin);
  push("Nachricht", form.notes || form.message);
  return lines.join("\n");
}

